import React from 'react';
import { formatPhoneNumber } from '../../../utils/validation';
import './PhoneInput.css';

const PhoneInput = ({ 
  value, 
  onChange, 
  error, 
  disabled, 
  placeholder = "Phone number",
  className = ""
}) => {
  const handleChange = (e) => {
    const rawValue = e.target.value;
    const formattedValue = formatPhoneNumber(rawValue);
    onChange(formattedValue);
  };

  const handleKeyPress = (e) => {
    // Allow only digits, backspace, delete, arrow keys, and tab
    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 
      'ArrowUp', 'ArrowDown', 'Tab', 'Enter'
    ];
    
    if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text');
    const formattedValue = formatPhoneNumber(pastedText);
    onChange(formattedValue);
  };

  return (
    <input
      type="tel"
      className={`form-input phone-input ${error ? 'error' : ''} ${className}`}
      value={value || ''}
      onChange={handleChange}
      onKeyDown={handleKeyPress}
      onPaste={handlePaste}
      placeholder={placeholder}
      disabled={disabled}
      inputMode="numeric"
      pattern="[0-9]*"
    />
  );
};

export default PhoneInput;
